import { resolveStartNodeId } from './scenario';
const DIALOG_SPEAKER_FOCUS_FLAG_KEY = '__dialogSpeakerFocusEnabled';
function readScenarioDialogSpeakerFocusEnabled(content) {
    const meta = content?.meta;
    const enabled = meta?.dialogSpeakerFocus?.enabled;
    return typeof enabled === 'boolean' ? enabled : true;
}
export function createInitialRunState(content) {
    return {
        currentNodeId: resolveStartNodeId(content),
        currentStepIndex: 0,
        variables: {},
        flags: {
            [DIALOG_SPEAKER_FOCUS_FLAG_KEY]: readScenarioDialogSpeakerFocusEnabled(content)
        },
        stats: {
            startedAt: new Date().toISOString(),
            playTimeMs: 0,
            collectedItemIds: [],
            correctAnswers: 0,
            totalQuestions: 0,
            minigameResults: []
        }
    };
}
export function normalizeRunState(state, content) {
    if (!state || typeof state !== 'object') {
        return content ? createInitialRunState(content) : defaultState();
    }
    const data = state;
    const normalizedFlags = isPlainObject(data.flags) ? data.flags : {};
    const shouldFillSpeakerFocusDefault = content && typeof normalizedFlags[DIALOG_SPEAKER_FOCUS_FLAG_KEY] !== 'boolean';
    return {
        currentNodeId: typeof data.currentNodeId === 'string'
            ? data.currentNodeId
            : content
                ? resolveStartNodeId(content)
                : null,
        currentStepIndex: Number.isFinite(data.currentStepIndex) ? Number(data.currentStepIndex) : 0,
        variables: isPlainObject(data.variables) ? data.variables : {},
        flags: shouldFillSpeakerFocusDefault
            ? {
                ...normalizedFlags,
                [DIALOG_SPEAKER_FOCUS_FLAG_KEY]: readScenarioDialogSpeakerFocusEnabled(content)
            }
            : normalizedFlags,
        stats: isPlainObject(data.stats)
            ? data.stats
            : {
                startedAt: new Date().toISOString(),
                playTimeMs: 0,
                collectedItemIds: [],
                correctAnswers: 0,
                totalQuestions: 0,
                minigameResults: []
            }
    };
}
function defaultState() {
    return {
        currentNodeId: null,
        currentStepIndex: 0,
        variables: {},
        flags: {}
    };
}
function isPlainObject(value) {
    return typeof value === 'object' && value !== null && (value.constructor === Object || Object.getPrototypeOf(value) === null);
}
//# sourceMappingURL=runState.js.map